import "../../style/Score.css"

const Score = ({score, scoreMax = 1}) => {



  let colorScoreText =
  score / scoreMax >= 0.75
      ? "#4A6FE6" //blue
      : score / scoreMax >= 0.5
      ? "#7EC886" //green
      : score / scoreMax >= 0.25
      ? "#CBCE70" //yellow
      : score / scoreMax > 0
      ? "#FF7F7F" //red
      : "#000000"; //black


  return (
    <div className="score_div">
      <p className="score_description">Score actuel :</p>
      <h2 style={{ color: colorScoreText }} className="score_text">
        {score}
      </h2>
    </div>
  );
};

export default Score;
